import React from 'react';

import { PageHeader } from 'Components/PageHeader';
import { getAppText } from 'Utils/text';
import { CancelInsuranceSection } from './CancelInsuranceSection';

export const CancelInsurancePage = (): React.ReactElement => {
  return (
    <>
      <PageHeader
        currentPage="cancel"
        pageTitle={getAppText('cancelInsurance.header')}
      />
      <div>
        <CancelInsuranceSection />
      </div>
    </>
  );
};
